export * from './lib/registry/dashboard-widget.model';
export * from './lib/registry/dashboard-widget-registry.service';
export * from './lib/registry/provide-dashboard-widget';
export * from './lib/page/dashboard-page.component';
